export const formatElapsedTime = (milliseconds: number): string => {
    if (milliseconds <= 0) {
        return '1 sec';
    }

    // Round UP to the nearest second
    const totalSeconds = Math.ceil(milliseconds / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const parts: string[] = [];

    if (hours > 0) {
        parts.push(`${hours} hr`);
    }

    if (minutes > 0) {
        parts.push(`${minutes} min`);
    }

    if (seconds > 0 || parts.length === 0) {
        parts.push(`${seconds} sec`);
    }

    return parts.join(' ');
};

export const getTranslationPluralKey = (baseKey: string, count: number): string => {
    return count === 1 ? baseKey : `${baseKey}_plural`;
};

export const capitalizeFirstLetter = (str: string): string => {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};
